import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IMyMonitoringUserModel } from '@apps-common/types/portal/users'

export const QUERY_MY_MONITORING_GET_MY_MONITORING_USER = (unitId?: string, userId?: number) =>
  ['getMyMonitoringUser', unitId, userId].filter(Boolean)

export const getMyMonitoringUser = async (unitId: string, userId: number): Promise<IMyMonitoringUserModel> =>
  axios.get(`/my-monitoring/sites/GetMyMonitoringUser?unitId=${unitId}&userId=${userId}`).then((res) => res.data?.data)

type QueryFnType = typeof getMyMonitoringUser

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
  userId: number
}

export const useMyMonitoringGetMyMonitoringUser = ({ config, unitId, userId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: QUERY_MY_MONITORING_GET_MY_MONITORING_USER(unitId, userId),
    queryFn: () => getMyMonitoringUser(unitId, userId)
  })
